/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { falseReducer, nullReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { ShortTermPoliciesState } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  DONE_FETCHING_SHORT_TERM_POLICIES,
  ERROR_FETCHING_SHORT_TERM_POLICIES,
  START_FETCHING_SHORT_TERM_POLICIES,
} from '../constants/index'
import type { ActionTypes } from '../types'

export const metaReducer = combineReducers<ShortTermPoliciesState['meta'], ActionTypes>({
  error: handleActions<ShortTermPoliciesState['meta']['error'], ActionTypes>(
    {
      [ERROR_FETCHING_SHORT_TERM_POLICIES]: payloadReducer,
      [START_FETCHING_SHORT_TERM_POLICIES]: nullReducer,
    },
    null
  ),
  fetching: handleActions<ShortTermPoliciesState['meta']['fetching'], ActionTypes>(
    {
      [START_FETCHING_SHORT_TERM_POLICIES]: trueReducer,
      [DONE_FETCHING_SHORT_TERM_POLICIES]: falseReducer,
    },
    false
  ),
})
